const state = {
    list: [],
};

const getters = {
};

const actions = {
};

const mutations = {
    push(state, notification) {
        let itemToAdd = notification;
        if (typeof notification === 'string') {
            itemToAdd = {
                name: notification,
                props: {},
            };
        }
        if (!itemToAdd.props) {
            itemToAdd.props = {};
        }
        state.list = state.list.concat([itemToAdd]);
    },
    pop(state) {
        const targetIndex = state.list.length - 1;
        const onClose = state.list[targetIndex].props.onClose;
        if (onClose !== undefined) {
            onClose();
        }
        state.list = state.list.slice(0, targetIndex);
    },
    popByIndex(state, index) {
        const onClose = state.list[index].props.onClose;
        if (onClose !== undefined) {
            onClose();
        }
        state.list = [ ...state.list.slice(0, index), ...state.list.slice(index + 1) ];
        // state.list.filter((_, xi) => xi !== index);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
